import clsx from "clsx";
import parse from "html-react-parser";
import { useState } from "react";

import EmbeddedForm from "@components/EmbeddedForm";

const BlogLayoutNewsletterForm = ({
	formHeading,
	formDescription,
	form,
	formData,
	successMessage,
}) => {
	const [isFormSuccessfullySubmitted, setIsFormSuccessfullySubmitted] =
		useState(false);

	const handleFormSuccess = () => {
		setIsFormSuccessfullySubmitted(true);
	};

	return (
		<>
			<div
				className={clsx(
					"BlogLayout__formContainer",
					"h-full",
					"bg-yellow-01",
					"p-7.5"
				)}
			>
				<h3
					className={clsx(
						"BlogLayout__formHeading font-medium",
						"mb-7.5",
						"text-3xl"
					)}
				>
					{formHeading}
				</h3>

        {!!formDescription && (
          <div className={clsx("BlogLayout__formDescription", "mb-7.5")}>
            {parse(formDescription)}
          </div>
        )}
				{!isFormSuccessfullySubmitted && (
					<div className={clsx("BlogLayout__embeddedForm")}>
						<EmbeddedForm
							form={form}
							formData={formData}
							onSuccess={handleFormSuccess}
							overrideButtonText={"Subscribe"}
						/>
					</div>
				)}
				{isFormSuccessfullySubmitted && !!successMessage && (
					<div
						className={clsx("BlogLayout__formSuccessMessage italic", "mb-7.5")}
					>
						{parse(successMessage)}
					</div>
				)}
			</div>
		</>
	);
};

export default BlogLayoutNewsletterForm;
